import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import {
    IRoleMain,
    MasterPages,
} from "../../../commonFunctions/CommonFunctions";
import { Header } from "../../../Components/Header/Header";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const RewardRuleList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const source = {
        url: "rewardRules/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: []
    };


    /**
     * Edit function
     * @param action
     * @param row
     */
    const handleAction = (action: string, row: any) => {
        // if (action === "Edit") {
        //     navigate(`/reward/rule/${row?._id}`);
        // }
        if (action === "Delete") {
            setSelectedId(row._id); // Set the ID of the row to be deleted
            setPopupOpen(true);
        }
    };
    const columns: IColumns[] = [
        {
            header: "Rule Name",
            fieldName: "name",
            tooltip: true,
            type: "default",
        },
        {
            header: "Condition Type",
            fieldName: "triggerType", // e.g., 'cardPoints' or 'purchaseAmount'
            tooltip: true,
            type: "default",
        },
        // {
        //     header: "Condition Value",
        //     fieldName: "triggerValue", // numeric threshold
        //     type: "default",
        // },

        {
            header: "Detail",
            fieldName: "description",
            tooltip: true,
            type: "default",
        },

        {
            header: "Reward Type",
            fieldName: "reward.type",
            tooltip: true,
            type: "default",
        },
        {
            header: "Updated At",
            fieldName: "updatedAt",
            type: "date",
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            // actions: [edit ? "Edit" : undefined, "Delete"],
            actions: ['Delete'],
            actionCallback: (action, row) => handleAction(action, row),
        },
    ];

    const handleClick = () => {
        navigate("/reward/rule/create");
    };
    const handleDelete = () => {
        dispatch(resetDataComponent("rewardRuleGrid"));
        showMessage("Reward Rule deleted successfully!", "success");
    };

    return (
        <>
            {" "}
            <Grid item container spacing={2}>
                <Grid item sm={12} xs={12}>
                    <Divider />
                </Grid>
            </Grid>
            <Header
                type="simple"
                isDivider={true}
                title="Reward Rules"
                id={"rewardRulesHeader"}
                headerSx={{ marginTop: 0 }}
            />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <WSDataGrid
                        id="rewardRuleGrid"
                        title="Reward Rules"
                        columns={columns}
                        source={source}
                        addButton={{ label: "New", color: "secondary" }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke"
                        }}
                    />
                    {selectedId !== null && (
                        <ConfirmationPopup
                            apiUrl={"rewardRules/delete"}
                            id={selectedId}
                            confirmMessage="Are you sure you want to delete this reward rule?"
                            open={isPopupOpen}
                            onClose={() => setPopupOpen(false)}
                            onConfirm={handleDelete}
                            permanent
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
});
